<nav class="navbar fixed-top">
  <div class="d-flex align-items-center navbar-left">
    <a (click)="menuButtonClick($event, sidebar.menuClickCount, sidebar.containerClassnames); false;"
      href="javascript:;" class="menu-button d-none d-md-block">
      <svg class="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
        <rect x="0.48" y="0.5" width="7" height="1" />
        <rect x="0.48" y="7.5" width="7" height="1" />
        <rect x="0.48" y="15.5" width="7" height="1" />
      </svg> {{" "}}
      <svg class="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
        <rect x="1.56" y="0.5" width="16" height="1" />
        <rect x="1.56" y="7.5" width="16" height="1" />
        <rect x="1.56" y="15.5" width="16" height="1" />
      </svg>
    </a>

    <a (click)="mobileMenuButtonClick($event, sidebar.containerClassnames)" href="javascript:;"
      class="menu-button-mobile d-xs-block d-sm-block d-md-none">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
        <rect x="0.5" y="0.5" width="25" height="1" />
        <rect x="0.5" y="7.5" width="25" height="1" />
        <rect x="0.5" y="15.5" width="25" height="1" />
      </svg>
    </a>

    <a class="navbar-logo" [routerLink]="adminRoot" >
      <!-- <span class="logo d-none d-xs-block"></span>
      <span class="logo-mobile d-block d-xs-none"></span> -->
      SISTEMA DE TURNO
    </a>

    <!-- <div class="search" (click)="searchAreaClick($event)">
      <input placeholder="Search..." [(ngModel)]="searchKey" (keyup)="searchKeyUp($event)">
      <span class="search-icon" (click)="searchClick($event)">
        <i class="simple-icon-magnifier"></i>
      </span>
    </div> -->

    <!-- <div class="btn-group ml-2" dropdown *ngIf="!isSingleLang">
      <button dropdownToggle type="button" class="language-button dropdown-toggle btn btn-light btn-sm">
        {{currentLanguage | uppercase}} <span class="caret"></span>
      </button>
      <ul *dropdownMenu class="dropdown-menu" role="menu">
        <li role="menuitem" *ngFor="let item of languages" (click)="onLanguageChange(item)"><a class="dropdown-item"
            href="javascript:;">{{item.label}}</a></li>
      </ul>
    </div> -->

  </div>

  <div class="navbar-right">
    
    <div class="header-icons d-inline-block align-middle">

      <div class="position-relative d-inline-block">
        <button class="header-icon btn btn-empty" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span *ngIf="isOnline" class="text-success text-bold"><i class="simple-icon-check"></i> OnLine</span>
          <span *ngIf="!isOnline" class="text-danger text-bold"><i class="simple-icon-close"></i> OffLine</span>
        </button>
      </div>

      <div class="d-none d-md-inline-block align-text-bottom mr-1">
        <div class="custom-control custom-switch" tooltip="Modo oscuro" placement="left">
          <input type="checkbox" class="custom-control-input" id="darkModeSwitch" [checked]="isDarkModeActive"
            (change)="onDarkModeChange($event)">
          <label class="custom-control-label" for="darkModeSwitch"></label>
        </div>
      </div>

    </div>

    <div class="user d-inline-block" dropdown>
      <button class="btn btn-empty p-0" type="button" dropdownToggle>
        <span class="name"><b>{{displayName}} - ({{userRol}})</b></span>
        <span>
          <img alt="Profile Picture" src="/assets/img/profiles/img_default.png" />
        </span>
      </button>

      <div class="dropdown-menu dropdown-menu-right mt-3" *dropdownMenu role="menu">
        <span class="dropdown-item c-pointer"><b>{{displayName}} - ({{userRol}})</b></span>
        <span class="dropdown-item c-pointer">{{userEmail}}</span>
        <li class="divider dropdown-divider"></li>
        <a class="dropdown-item c-pointer" (click)="changePassword()">Cambiar contraseña</a>
        <!-- <li class="divider dropdown-divider"></li> -->
        <a class="dropdown-item c-pointer" (click)="onSignOut()">Cerrar sesión</a>
      </div>
    </div>

  </div>
</nav>
